import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { SearchI } from '../../../../Pages/SearchService'
import { searchService } from '../../../../services/servico'
import { EmptyList } from './components/EmptyList'

interface ServiceMapped {
  value: string
  name: string
}

interface InputDropdownProps {
  dropdownRef: React.MutableRefObject<HTMLDivElement>
  inputValue: string
  size?: 'small' | 'large' // O 'LARGE' É ADAPTADO ESPECIFICAMENTE PARA O SEARCH INPUT DA HOME
}

export default function SearchInputDropdown({
  dropdownRef,
  inputValue,
  size = 'small',
}: InputDropdownProps): JSX.Element {
  const [isLoading, setIsloading] = useState(false)
  const [serviceList, setServiceList] = useState<ServiceMapped[]>([])

  const history = useHistory()

  const useStyles = makeStyles((theme: Theme) => ({
    dropdown: {
      position: 'absolute',
      top: size === 'small' ? '110%' : '75%',
      left: size === 'small' ? 0 : 20,
      backgroundColor: 'white',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      zIndex: 1,
      maxHeight: '200px',
      overflowY: 'auto',
      borderRadius: '4px',
      width: size === 'small' ? '100%' : 'calc(100% - 40px)',
      [theme.breakpoints.down('sm')]: {
        maxHeight: '150px',
      },
    },
    dropdownItem: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#f0f0f0',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(14),
      },
    },
  }))

  const classes = useStyles()

  const fetchServices = async (value: string) => {
    setServiceList([])
    try {
      setIsloading(true)
      const { data } = await searchService(value, 1)
      setServiceList(
        data?.results.map((item: SearchI) => {
          return {
            value: item.slug,
            name: item.titulo,
          }
        }),
      )
    } catch (error) {
      console.error(error)
    } finally {
      setIsloading(false)
    }
  }

  useEffect(() => {
    if (inputValue.length > 0) {
      fetchServices(inputValue)
    }
  }, [inputValue])

  return (
    <div className={classes.dropdown} ref={dropdownRef}>
      {serviceList.length > 0 ? (
        serviceList.map((item) => (
          <Typography
            key={item.value}
            className={classes.dropdownItem}
            onClick={() => history.push(`/servico/${item.value}`)}
          >
            {item.name}
          </Typography>
        ))
      ) : (
        <EmptyList
          classes={classes}
          isLoading={isLoading}
          onEmptyMessage="Nenhum serviço encontrado"
          onLoadingMessage="Carregando serviços..."
        />
      )}
    </div>
  )
}
